import type { IncentivesRecord } from "@dealer-center/ddc-pages-incentives-manager-interface";

export const containsLockedMake = (
  selections: number[],
  incentives: IncentivesRecord[] | undefined,
  isMakeLocked: (make: string) => boolean | undefined
): boolean => {
  return selections.some(index => {
    const incentive = incentives?.[index];
    if (incentive) {
      return isMakeLocked(incentive.applicableMake);
    }
    return false;
  });
};

export const containsCPOCondition = (
  selections: number[],
  incentives: IncentivesRecord[] | undefined
): boolean => {
  return incentives?.[selections[0]]?.applicableCondition === "CPO";
};

export const shouldDisableAddCloneIncentives = (
  permissions?: string[]
): boolean => {
  if (permissions) {
    return !permissions.includes("INCENTIVESMANAGER.MANUALINSERT");
  }
  return false;
};

interface ButtonConfig {
  label: string;
  noBulk: boolean;
}

const isAddEditDelete = (button: ButtonConfig): boolean => {
  return (
    button.label === "EDIT" ||
    button.label === "CLONE_INCENTIVE" ||
    button.label === "DELETE"
  );
};

export const getButtonDisabledState = (
  button: ButtonConfig,
  selections: number[],
  incentives: IncentivesRecord[] | undefined,
  isMakeLocked: (make: string) => boolean | undefined,
  permissions?: string[]
): boolean => {
  return (
    (isAddEditDelete(button) && shouldDisableAddCloneIncentives(permissions)) ||
    containsLockedMake(selections, incentives, isMakeLocked) ||
    selections.length === 0 ||
    (button.noBulk && selections.length > 1) ||
    (button.label === "CLONE_INCENTIVE" &&
      containsCPOCondition(selections, incentives)) ||
    (button.label === "EDIT" && containsCPOCondition(selections, incentives))
  );
};
